import type { Team } from '../types';

export type TeamColors = Readonly<Record<Team, number>>;

export interface TeamPresentation {
  readonly colors: TeamColors;
}

export const DEFAULT_TEAM_COLORS: TeamColors = Object.freeze({
  blue: 0x45a7ff,
  orange: 0xff7f32,
});

const DEFAULT_TEAM_PRESENTATION: TeamPresentation = Object.freeze({
  colors: DEFAULT_TEAM_COLORS,
});

export function defaultTeamPresentation(): TeamPresentation {
  return DEFAULT_TEAM_PRESENTATION;
}

export function validateTeamPresentation(presentation: TeamPresentation): void {
  validateColor(presentation.colors.blue, 'blue');
  validateColor(presentation.colors.orange, 'orange');
}

function validateColor(value: number, team: Team): void {
  if (!Number.isSafeInteger(value) || value < 0 || value > 0xffffff) {
    throw new Error(`Team presentation ${team} color must be an RGB integer between 0x000000 and 0xFFFFFF.`);
  }
}
